<template>
	<v-expansion-panels v-model="model" :class="{ wide }" class="Disclosure">
		<v-expansion-panel :eager="eager" class="disclosureHeader">
			<v-expansion-panel-title :data-cy="dataCy">
				<template v-slot:default>
					<div class="column">
						<div class="row">
							<v-icon v-if="lock" size="24px" color="gray">mdi-lock-outline</v-icon>
							<span :class="smallTitle ? 'small-title' : 'normal-title'">{{ title }}</span>
							<v-btn v-if="deleteIcon" size="small" icon color="#f34545" style="cursor:pointer; float: right;" @click.stop="$emit('remove')">
								<v-icon>mdi-delete</v-icon>
							</v-btn>
						</div>
						<div v-if="warning" class="row">
							<img src="@/assets/icons/icon-warning.svg" class="icon" />
							<span class="warning-text">{{ message }}</span>
						</div>
						<div v-if="error" class="row">
							<img src="@/assets/icons/icon-error.svg" class="icon error-icon" />
							<span class="error-text">{{ message }}</span>
						</div>
						<div v-if="info" class="row">
							<v-icon size="24px" color="#8F8F8F">mdi-information</v-icon>
							<span class="info-text">{{ message }}</span>
						</div>
						<div v-if="messageInfo" class="row">
							<v-icon size="24px" color="#8F8F8F">mdi-information</v-icon>
							<span class="info-text">{{ messageInfo }}</span>
						</div>
					</div>
					<div @click.stop.prevent>
						<slot name="header-accessory" />
					</div>
				</template>
			</v-expansion-panel-title>
			<v-expansion-panel-text :class="{ disabled: lock }">
				<slot />
			</v-expansion-panel-text>
		</v-expansion-panel>
	</v-expansion-panels>
</template>

<script>
export default {
	props: {
		title: String,
		dataCy: String,
		lock: Boolean,
		warning: Boolean,
		info: Boolean,
		error: Boolean,
		message: String,
		expanded: Boolean,
		deleteIcon: Boolean,
		smallTitle: Boolean,
		eager: Boolean,
		// make more room for wider content
		wide: Boolean,
		messageInfo: String,
	},
	data() {
		return {
		model: -1
	}},
	methods: {
		open() {
			this.model = 0
		},
		close() {
			this.model = -1
		},
		toggle() {
			if (this.model === -1) {
				this.open()
			} else {
				this.close()
			}	
		},
	},
	mounted() {
		if (this.expanded) {
			this.model = 0
		}
	}
}
</script>

<style scoped>
.v-expansion-panel-title { font-size: 14pt !important; word-break: break-all; }
.v-expansion-panel-header { padding: 20px 25px 20px 25px !important; border-bottom: 1px solid #dedede; }
.disabled { opacity: 0.75; pointer-events: none; background-color: #fafafa; }
.Disclosure .v-expansion-panel-text.disabled ::v-deep .TiptapField .vuetify-pro-tiptap-editor__content { pointer-events: auto; }
.warning-text { font-size: 12pt !important; color: #ffb400 !important; font-weight: 500; }
.error-text { font-size: 12pt !important; color: #f34545 !important; font-weight: 500; }
.info-text { font-size: 12pt !important; color: #8F8F8F !important; font-weight: 500; }
.row {
	flex: 1;
	display: flex;
	align-items: center;
	gap: 10px;
}
.column {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 10px;
}
.icon { width: 16px; height: 16px; }
.error-icon { filter: brightness(100%) saturate(300%); }
.small-title { font-size: 14pt !important; }

.disclosureHeader { padding-right: 2rem; padding-left: 2rem; }

@media screen and (max-width: 1270px) {
	.wide .disclosureHeader { padding-right: 0; padding-left: 0; }
	/* for the wide header the title padding needs to compensate the missing outer padding */
	.wide .v-expansion-panel-title { padding: 0 56px; }
}

@media screen and (max-width: 1024px) {
	.disclosureHeader { padding-right: 0; padding-left: 0; }
	.wide .v-expansion-panel-title { padding: 0 24px; }
}
</style>

<style>
@media screen and (max-width: 1270px) {
	.Disclosure.wide .v-expansion-panel-text__wrapper { padding: 8px; }
}

@media screen and (max-width: 600px) {
	.Disclosure .v-expansion-panel-text__wrapper { padding: 8px; }
}
</style>